import React, { Component } from "react";
import { isMobile, isUserloggedIn } from "@utils/common";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showSplash, hideSplash } from "@src/action";
import get from "lodash/get";
import { getKey, setKey } from "@utils/storage";
import { LOCALSTORAGE } from "@constants";
import { fetchPubnubHistory } from "@containers/Home/APIs/actions";
import { URL } from "@constants/routeConstants";
import "./style.scss";
import { BROWSER_TYPE } from "@constants/browser";
import { getSystemDetails } from "@utils/browserEnvironment";

// Lala
import { user_Info } from "@src/jsonfile.json";
// 🔧 Outside the class component (or as static inside the class)
const VIDEO_BREAKPOINTS = [
  // 📱 Mobile Portrait
  {
    query: "(max-width: 390px) and (orientation: portrait)",
    srcKey: "Logo_android_portrait_2",
  },
  {
    query:
      "(min-width: 391px) and (max-width: 450px) and (orientation: portrait)",
    srcKey: "Logo_android_portrait",
  },
  {
    query:
      "(min-width: 451px) and (max-width: 600px) and (orientation: portrait)",
    srcKey: "Logo_tab_portrait",
  },

  // 📱 Mobile Landscape
  {
    query:
      "(min-width: 600px) and (max-width: 767px) and (orientation: landscape)",
    srcKey: "Logo_tab_landscap",
  },

  // 📱 7-inch Tablets
  {
    query:
      "(min-width: 600px) and (max-width: 720px) and (orientation: portrait)",
    srcKey: "Logo_tab_8_portrait",
  },
  {
    query:
      "(min-width: 600px) and (max-width: 720px) and (orientation: landscape)",
    srcKey: "Logo_tab_8_landscape",
  },

  // 📱 8-inch Tablets
  {
    query:
      "(min-width: 721px) and (max-width: 800px) and (orientation: portrait)",
    srcKey: "Logo_tab_8_portrait",
  },
  {
    query:
      "(min-width: 721px) and (max-width: 800px) and (orientation: landscape)",
    srcKey: "Logo_tab_8_landscape",
  },

  // 📱 10-inch Tablets
  {
    query:
      "(min-width: 801px) and (max-width: 1024px) and (orientation: portrait)",
    srcKey: "Logo_tab_10_portrait",
  },
  {
    query:
      "(min-width: 801px) and (max-width: 1024px) and (orientation: landscape)",
    srcKey: "Logo_tab_10_landscape",
  },
];

class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = {
       isTable: "",
      style: {
        background:
          "linear-gradient(69.87deg, #070316 43.33%, #130837 71.53%); !important",
        display: "none",
      },
    };
    this.myRef = React.createRef();
    this.systemDetail = "";
  }
  componentDidMount = async () => {
    console.log("splash-loading", this.myRef);
    this.systemDetail = getSystemDetails();

    const match = VIDEO_BREAKPOINTS.find(
      (bp) => window.matchMedia(bp.query).matches
    );

    const isTable = match?.srcKey || "Logo_tab_10_landscape";
    // const src = user_Info?.Splash_Logo?.[srcKey];
    // const isTable = match?.name || "";

    this.setState({ isTable });



    let deepLinked = JSON.parse(getKey(LOCALSTORAGE.DEEPLINK)) === true;
    // let userInfo2 = JSON.parse(getKey(LOCALSTORAGE.USER_INFO));
    // localStorage.setItem("disabledBack", false);
    if (!deepLinked) {
      this.props.showSplash();
    }
    //
    // let hideSplashS = JSON.parse(getKey("logout_hideSPlash"));
    // if (hideSplashS) {
    //   this.props.hideSplash();
    //   localStorage.removeItem("logout_hideSPlash");
    // }
    // setKey(LOCALSTORAGE.HIDE_SPLASH, false);
    
    setKey(LOCALSTORAGE.DEEPLINK, JSON.stringify(false));
  };

  componentDidUpdate = () => {
    // localStorage.setItem("disabledBack", false);
    // setKey(LOCALSTORAGE.HIDE_SPLASH, false);
    if (this.myRef.current && this.props.splash) {
      this.myRef.current.addEventListener("playing", () => {
        this.setState({
          style: {
            background:
              "linear-gradient(69.87deg, #070316 43.33%, #130837 71.53%); !important",
            display: "block",
          },
        });
      });

      this.myRef.current.play();
      this.myRef.current.addEventListener("ended", () =>
        this.props.hideSplash()
      );
      this.myRef.current.addEventListener("error", () =>
        this.props.hideSplash()
      );
    }
  };

  showSplashVideo = () => {
    let paramData = new URLSearchParams(location.search);
    let cartId = paramData.get("cartId");
    let statusInfo = paramData.get("status");
    let tickTick = paramData.get("tickTick");
    let tickTick2 = paramData.get("tickTick");
    const urlArr = location.pathname.split("/");

    let showSplash = [
      URL.PAGE_NOT_FOUND,
      URL.BEST_VIEW_MOBILE,
      URL.APP_INSTALL,
      URL.SUBSCRIPTION_TRANSACTION,
      URL.SUBSCRIPTION_TRANSACTION_REDIRECT,
      URL.HELP_CENTER,
      URL.HELP_CENTER_ATV,
      URL.TRANSACTIONS,
      URL.SUBSCRIPTION_CAMPAIGN,
      URL.SUBSCRIPTION_DISCOUNT,
      URL.SEE_ALL,
      URL.CONTINUE_WATCHING_SEE_ALL,
      URL.DETAIL,
      URL.PLAYER,
      URL.EPISODE,
      URL.QR_LOGIN,
    ].includes(urlArr[1]);

    let showSplashGuestUser = [
      URL.PAGE_NOT_FOUND,
      URL.BEST_VIEW_MOBILE,
      URL.APP_INSTALL,
      URL.SUBSCRIPTION_TRANSACTION,
      URL.SUBSCRIPTION_TRANSACTION_REDIRECT,
      URL.HELP_CENTER,
      URL.HELP_CENTER_ATV,
      URL.TRANSACTIONS,
      URL.SUBSCRIPTION_CAMPAIGN,
      URL.SUBSCRIPTION_DISCOUNT,
      URL.SEE_ALL,
      URL.CONTINUE_WATCHING_SEE_ALL,
      URL.DETAIL,
      URL.PLAYER,
      URL.HOME,
      URL.LIVE_TV,
      URL.MOVIES,
      URL.DRAMA,
      URL.EPISODE,
      URL.QR_LOGIN,
    ].includes(urlArr[1]);
    if ((cartId && statusInfo) || tickTick || statusInfo) {
      return false;
    }
    return isUserloggedIn() ? !showSplash : !showSplashGuestUser;
  };

  getResponsiveVideoSource = () => {
    const srcKey = this.state.isTable || "Logo_tab_10_landscape";
    const src = user_Info?.Splash_Logo?.[srcKey];
    // this.setState({ isTable: srcKey });
    return src ? <source className={srcKey} src={src} type="video/mp4" /> : null;
  };

  shouldHideSplash = () => {
    const isSafari = this.systemDetail?.browser === BROWSER_TYPE.SAFARI;

    return (
      (isSafari) ||
      !this.props.splash ||
      !this.showSplashVideo()
    );
  };

  render() {
    if (this.shouldHideSplash()) {
      return null;
    }

    return (
      <div className="fullscreen-bg">
        <video
          className={`fullscreen-bg__video ${this.state.isTable}`}
          muted
          autoPlay
          playsInline
          ref={this.myRef}
          onError={this.props.hideSplash}
          style={this.state.style}
        >
          {this.getResponsiveVideoSource()}
        </video>
      </div>
    );
  }
}

Splash.propTypes = {
  showSplash: PropTypes.func,
  splash: PropTypes.bool,
  hideSplash: PropTypes.func,
  fetchPubnubHistory: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    splash: get(state.commonContent, "splash"),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        showSplash,
        hideSplash,
        fetchPubnubHistory,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Splash);
